export const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="#505254" className="w-4 h-4">
    <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"/>
  </svg>
);
